import React from 'react'
import { addSlashInternalLink } from '../../helper'

export const ImportantNoticeBlock = ({ notice, color, headlineNotice, detailNotice }) => {
    return (
        <>
            {
                color === 'red' ? (
                    <div className="red-noice" >
                        <p>{headlineNotice}</p>
                        <p>{detailNotice}</p>
                    </div>
                ) : (
                        <div className="yellow-noice" dangerouslySetInnerHTML={{ __html: addSlashInternalLink(notice) }}></div>
                    )
            }
        </>
    )
}

export default ImportantNoticeBlock
